import React from 'react';

import ChildrenPropType from 'lib/CustomPropTypes/children';

function Grid(props) {
  const { children } = props;

  return (
    <div className="layout-grid-container today-cover-tabbed__grid">
      { children }
    </div>
  );
}

Grid.propTypes = {
  children: ChildrenPropType.isRequired,
};

export default Grid;
